import { defaultDateString } from "src/components/common/common";
import { defaultProductDowntimeDto, ProductDowntimeDto } from "src/dtos/productDowntime/ProductDowntimeDto";
import { ProductResultDto } from "src/dtos/productResult/ProductResultDto";
import { ProductWorkDto } from "src/dtos/productWork/ProductWorkDto";
import { getFutureWeekdayExceptTodayAndTomorrow } from "src/utils/date/dateUtils";
import { formatDate, toLocalDateTime } from "src/utils/string/stringUtil";

export interface PRD3020_R01Dto extends ProductResultDto {


	itemCost: number;

	itemSpec: string;
	itemUnit: string;

	productResultNo: string;
	productDt: string | undefined;

	warehouseCd: string;
	warehouseNm: string;

	productQty: number;
	badQty: number;
	acceptQty: number;

	downtimeSet: string;

	downtimeStartTime: string | undefined;
	downtimeStartDt: string | undefined;
	downtimeStartHour: number;
	downtimeStartMinute: number;

	downtimeEndTime: string | undefined;
	downtimeEndDt: string | undefined;
	downtimeEndHour: number;
	downtimeEndMinute: number;

	downtimeCase: string;
    
}

export interface PRD3020_R01DetailDto extends ProductDowntimeDto {

}

export const defaultPRD3020_R01DetailDto: PRD3020_R01DetailDto = {
	...defaultProductDowntimeDto,
};

/**
 * 생산 실적 관리의 단일 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultPRD3020_R01Dto: PRD3020_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: '',
	inspectQty: 0,
	inspectYn: 'N',
	remark: '',

	itemCost: 0,

	downtimeSet: '',
	
	downtimeStartTime: toLocalDateTime(new Date()),
	downtimeStartDt: formatDate(new Date()),
	downtimeStartHour: 0,
	downtimeStartMinute: 0,

	downtimeEndTime: toLocalDateTime(new Date()),
	downtimeEndDt: formatDate(new Date()),
	downtimeEndHour: 0,
	downtimeEndMinute: 0,
	
	downtimeCase: '',

	inserted: false,
	isModified: false

};
